import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class PeopleContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        const content = JSON.parse(localStorage.getItem("pagecontents"));
        const people = JSON.parse(localStorage.getItem("people"));

        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
           <div className="body-block" data-v-e8f34808="">
      <div data-v-e8f34808="" className="ppl">
        
        <section className="people-block section-padded">
          <div
            data-aos="fade-up"
            data-aos-duration="500"
            className="content aos-init aos-animate"
          >
            <blockquote>
              Our people are our greatest assets. The driving force behind our
              success, delivering excellence with passion and dedication.
            </blockquote>

            <h1>{content[0].title}</h1>

           <div dangerouslySetInnerHTML={{ __html:  content[0].description }} />
        
          </div>
        </section>

        <div className="spacer" />

        {/* CEO message */}
        <section className="people-block section-padded">
          <div
            data-aos="fade-up"
            data-aos-duration="500"
            className="content aos-init aos-animate"
            style={{ marginTop: 0 }}
          >
            <h1>{content[1].title}</h1>

            <hr
              style={{
                margin: "30px auto",
                borderTop: 0,
                borderRight: 0,
                borderBottom: "1px solid var(--main-blue)",
                borderLeft: 0,
                display: "block",
                opacity: 0.3,
              }}
            />

           <div dangerouslySetInnerHTML={{ __html:  content[1].description }} />
          </div>
        </section>

        <div className="spacer" />

        {/* Senior Management */}
        <section className="section-fullwidth background-blue board-bg people-section">
          <div className="people single-wrap">
            <div className="person person-spacer">
              <div className="person-spacer-content">
                <h1 data-aos="fade-up" data-aos-duration="500" className="people-tag aos-init">
                  Senior Management
                </h1>
              </div>
            </div>

            {people.Senior_ManageMent.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}
 
          </div>
        </section>
  {people.Strategic_Management.length > 0 &&
  <>
        {/* Management Teams */}
        <section className="people-block section-padded">
          <div
            data-aos="fade-up"
            data-aos-duration="500"
            className="content aos-init"
          >
            <h1>{content[2].title}</h1>
             <div dangerouslySetInnerHTML={{ __html:  content[2].description }} />
          </div>
        </section>

        <div className="spacer" />
 
        <section className="section-fullwidth background-blue board-bg people-section">
          <div className="people single-wrap">
            <div className="person person-spacer" style={{ width: "100%" }}>
              <div data-aos="fade-up" data-aos-duration="500" className="person-spacer-content aos-init">
                <h1 className="people-tag">Strategic Management</h1>
              </div>
            </div>
          </div>
 <div className="people people-wrap"> 
           {people.Strategic_Management.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}

          </div>
        </section>
    

        <div className="spacer" />
        </>
    }

        {/* Department Heads */}
        <section className="section-fullwidth people-section text-colored">
          <div className="people single-wrap">
            <div className="person person-spacer" style={{ width: "100%" }}>
              <div className="person-spacer-content">
                <h1 data-aos="fade-up" data-aos-duration="500" className="people-tag aos-init">
                  Department Heads
                </h1>
              </div>
            </div>
          </div>

          <div className="people people-wrap">
            {people.Department_Heads.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}
 
          </div>
        </section>

      
        {people.Management.length > 0 &&
  <> 
  <div className="spacer" />
        {/* Management */}
        <section className="section-fullwidth background-blue board-bg people-section">
          <div className="people single-wrap">
            <div className="person person-spacer" style={{ width: "100%" }}>
              <div className="person-spacer-content">
                <h1 data-aos="fade-up" data-aos-duration="500" className="people-tag aos-init">
                  Management
                </h1>
              </div>
            </div>
          </div>

          <div className="people people-wrap">
             {people.Management.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}
 
          </div>
        </section>

        <div className="spacer" />
        </>
    }
  {people.Supervisors.length > 0 &&
  <> 
        {/* Supervisors */}
        <section className="section-fullwidth people-section text-colored">
          <div className="people single-wrap">
            <div className="person person-spacer" style={{ width: "100%" }}>
              <div className="person-spacer-content">
                <h1 data-aos="fade-up" data-aos-duration="500" className="people-tag aos-init">
                  Supervisors
                </h1>
              </div>
            </div>
          </div>

          <div className="people single-wrap">
           {people.Supervisors.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}

          </div>
        </section>

        <div className="spacer" />

        </>
    }

        {/* Specialists */}
        <section className="section-fullwidth people-section text-colored">
          <div className="people single-wrap">
            <div className="person person-spacer" style={{ width: "100%" }}>
              <div className="person-spacer-content">
                <h1 data-aos="fade-up" data-aos-duration="500" className="people-tag aos-init">
                  SPECIALISTS
                </h1>
              </div>
            </div>
          </div>

          <div className="people people-wrap">
                       {people.Specialists.map((item, index) => (

            <div className="person">
              <div data-aos="fade-up" data-aos-duration="500" className="person-image aos-init">
                <img
                  src={item.image}
                  alt={item.name}
                />
              </div>
              <div className="person-content">
                <div className="person-name">{item.name}</div>
                <div className="person-title">{item.position}</div>
              </div>
            </div>
            ))}


            
            
          </div>
        </section>
 
        
      </div>
    </div>
 
        </div>
       

    );
 
    }
}

export default PeopleContent;